import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    product: {
      label: {
        id: 'properties.product',
        defaultMessage: 'Product',
        description: 'label of the form field product',
      },
      placeholder: {
        id: 'properties.searchProduct',
        defaultMessage: 'Search product',
        description: 'placeholder of the form field product',
      },
    },
    sku: {
      label: {
        id: 'properties.sku',
        defaultMessage: 'SKU',
        description: 'label of the form field sku',
      },
    },
    position: {
      label: {
        id: 'properties.position',
        defaultMessage: 'Position',
        description: 'label of the form field position',
      },
    },
    addAnotherProduct: {
      label: {
        id: 'properties.addAnotherPreferredPosition',
        defaultMessage: 'Add another preferred position',
        description: 'label of the form field add another product',
      },
    },
  },
};

export default defineMessages(translations);
